'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LanguageText = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _inputs = require('./inputs');

var _Text2 = require('./Text');

var _MinusIcon = require('mdi-react/MinusIcon');

var _MinusIcon2 = _interopRequireDefault(_MinusIcon);

var _nodeToolbox = require('@esnpm/node-toolbox');

var _validators = require('./validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classnames = require('classnames');

var LanguageText = exports.LanguageText = (_temp = _class = function (_Text) {
	_inherits(LanguageText, _Text);

	function LanguageText(props) {
		_classCallCheck(this, LanguageText);

		return _possibleConstructorReturn(this, (LanguageText.__proto__ || Object.getPrototypeOf(LanguageText)).call(this, props));
	}

	_createClass(LanguageText, [{
		key: 'renderInput',
		value: function renderInput(props) {
			var _this2 = this;

			var UnsetWidth = false;
			if (this.props.size !== null) {
				UnsetWidth = true;
			}
			return _react2.default.createElement(
				_reactBootstrap.InputGroup,
				{
					className: classnames({ "UnsetWidth": UnsetWidth }) },
				_react2.default.createElement(
					_reactBootstrap.InputGroup.Addon,
					{ style: { "width": "50px" } },
					this.props.languageCode
				),
				_react2.default.createElement(_inputs.ESInput.Text, props),
				_react2.default.createElement(
					_reactBootstrap.InputGroup.Button,
					{
						className: classnames({ "UnsetWidth": UnsetWidth })
					},
					_react2.default.createElement(
						_reactBootstrap.Button,
						{
							className: "InputGroupButton",
							onClick: function onClick() {
								return _this2.props.onRemove(_this2.props.languageCode);
							}
						},
						'\xA0',
						_react2.default.createElement(_MinusIcon2.default, null)
					)
				)
			);
		}
	}]);

	return LanguageText;
}(_Text2.Text), _class.defaultProps = Object.assign({}, _Text2.Text.defaultProps, {
	noLabel: true,
	languageCode: null,
	onRemove: function onRemove() {},
	allowedCharacters: '[a-zA-Z0-9áÁàÀâÂäÄãÃåÅçÇðÐéÉèÈêÊëËíÍìÌîÎïÏñÑóÓòÒôÔöÖõÕßþÞúÚùÙûÛüÜýÝÿ ?!-+@]',
	validators: (0, _nodeToolbox.combineListsSingleType)(_Text2.Text.defaultProps.validators, [new _validators.ESValidator.MinLength(2)])

}), _class.propTypes = Object.assign({}, _Text2.Text.propTypes, {
	languageCode: _propTypes.PropTypes.string.isRequired,
	onRemove: _propTypes.PropTypes.func
}), _temp);